import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  reminderLogs: [],
  loadingReminderLogs: false,
  errorLoadingReminderLogs: null,
  pagination: {},
  serverStatus: null,
};

export const reminderLogSlice = createSlice({
  name: "reminderLog",
  initialState,
  reducers: {
    setLoadingReminderLogs: (state) => {
      state.loadingReminderLogs = true;
      state.errorLoadingReminderLogs = null;
    },
    setReminderLogs: (state, { payload }) => {
      state.loadingReminderLogs = false;
      state.reminderLogs = payload;
    },
    setErrorLoadingReminderLogs: (state, { payload }) => {
      state.loadingReminderLogs = false;
      state.errorLoadingReminderLogs = payload;
    },
    setReminderLogPagination: (state, { payload }) => {
      state.pagination = payload;
    },
    setServerResponseStatus(state, { payload }) {
      state.serverStatus = payload;
    },
  },
});

export const {
  setLoadingReminderLogs,
  setReminderLogs,
  setErrorLoadingReminderLogs,
  setReminderLogPagination,
  setServerResponseStatus,
} = reminderLogSlice.actions;

export default reminderLogSlice.reducer;
